import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import EmailEditor from 'react-email-editor';
import PropTypes from 'prop-types'

const VmoReactEmailEditor = forwardRef(({ onExportHtml, initialDesign, ...rest }, ref) => {
    const emailEditorRef = useRef(null);
    useImperativeHandle(ref, () => ({
        exportHtml: () => {
            const unlayer = emailEditorRef.current?.editor;

            unlayer?.exportHtml((data) => {
                onExportHtml(data);
            });
        }
    }));
    const onReady = (unlayer) => {
        if (initialDesign) {
            unlayer.loadDesign(initialDesign);
        }
    };
    return <EmailEditor ref={emailEditorRef} onReady={onReady} {...rest} />
})


export default VmoReactEmailEditor

VmoReactEmailEditor.propTypes = {
    onExportHtml: PropTypes.func,
    initialDesign: PropTypes.object

}